(function () {
  function initRoot(root) {
    var tabButtons = root.querySelectorAll('[data-al-tab]');
    var panels = root.querySelectorAll('[data-al-panel]');

    tabButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var target = button.getAttribute('data-al-tab');

        tabButtons.forEach(function (tab) {
          var isActive = tab === button;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach(function (panel) {
          var isActive = panel.getAttribute('data-al-panel') === target;
          panel.classList.toggle('is-active', isActive);

          if (isActive) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', 'hidden');
          }
        });
      });
    });

    var modal = root.querySelector('[data-ai-modal]');
    var modalTitle = root.querySelector('[data-ai-modal-title]');
    var modalSymbol = root.querySelector('[data-ai-modal-symbol]');
    var modalRole = root.querySelector('[data-ai-modal-role]');
    var modalDescription = root.querySelector('[data-ai-modal-description]');
    var closeElements = root.querySelectorAll('[data-ai-close]');
    var cards = root.querySelectorAll('[data-ai-card]');
    var lastTrigger = null;

    if (!modal || !cards.length) return;

    function openModal(card) {
      var source = card.querySelector('.al-it__modal-source');

      lastTrigger = card;

      modalTitle.textContent = card.getAttribute('data-ai-title') || '';
      modalSymbol.textContent = card.getAttribute('data-ai-symbol') || '';
      modalRole.textContent = card.getAttribute('data-ai-role') || '';
      modalDescription.innerHTML = source ? source.innerHTML : '';

      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('al-it-modal-lock');

      var closeButton = modal.querySelector('.al-it__modal-close');
      if (closeButton) closeButton.focus();
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('al-it-modal-lock');

      if (lastTrigger) {
        lastTrigger.focus();
        lastTrigger = null;
      }
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        openModal(card);
      });

      card.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openModal(card);
        }
      });
    });

    closeElements.forEach(function (element) {
      element.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal();
      }
    });
  }

  function init() {
    document.querySelectorAll('.al-it').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
